import { provideState } from '@ngrx/store';

import { inboxFeature } from './inbox.reducer';

export const inboxStore = [provideState(inboxFeature)];
